import { render } from "./PrvComponent.vue?vue&type=template&id=c0d31aea"
import script from "./PrvComponent.vue?vue&type=script&lang=js"
export * from "./PrvComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__